export default __webpack_public_path__ + "static/media/Polygon 2.47628b01.svg";